module.exports = __webpack_public_path__ + "img/icon-news.66307539.png";